module.exports = __webpack_public_path__ + "img/image (4).ac478f3f.jpg";